import { render, staticRenderFns } from "./subNav.vue?vue&type=template&id=542945fc&scoped=true&"
import script from "./subNav.vue?vue&type=script&lang=js&"
export * from "./subNav.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./subNav.vue?vue&type=style&index=0&id=542945fc&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "542945fc",
  "2df0eed9"
  
)

export default component.exports